// This is a utility component to intercept http responses
// based on https://blog.liplex.de/axios-interceptor-to-refresh-jwt-token-after-expiration/
// refer to documentation
// @author lamrpalex

import axios from 'axios';
import { Promise } from 'es6-promise';
import { getCookieValue } from './cookiesUtil';

const URL = `${process.env.REACT_APP_SERVER_URL}`;

function getNewToken() {
  return new Promise((resolve, reject) => {
    axios
      .get(`${URL}/api/authenticate/refreshJWT`, {
        headers: {
          Authorization: `Bearer ${getCookieValue('refreshTokenJWT')}`
        }
      })
      .then((response) => {
        document.cookie = `accessToken=${response.data.accessToken}`;
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

const axiosInterceptor = () => {

  axios.interceptors.response.use(
    (response) =>
      // Return a successful response back to the calling service
      response,
    (error) => {
      // Return any error which is not due to authentication back to the calling service
      if (error.message === 'Error: authentication failed' || error.response?.status !== 401) {
        return new Promise((resolve, reject) => {
          reject(error);
        });
      }

      // Logout user if token refresh didn't work or user is disabled
      if (error.config.url === `${URL}/api/authenticate/refreshJWT`) {
        return new Promise((resolve, reject) => {
          reject(new Error('authentication failed'));
        });
      }

      // Try request again with new token
      return getNewToken()
        .then(() => {
          // New request with new token
          const { config } = error;
          // I have to put jwt new token
          config.headers.Authorization = `Bearer ${getCookieValue('accessToken')}`;

          return new Promise((resolve, reject) => {
            axios
              .request(config)
              .then((response) => {
                resolve(response);
              })
              .catch((errorFromNewRequest) => {
                reject(errorFromNewRequest);
              });
          });
        })
        .catch((errorFromTokenRequest) => {
          // here the error returns to the triggered request
          throw errorFromTokenRequest;
        });
    }
  );
};

export default axiosInterceptor;
